module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.39c8bd5a.png";